export default {"src":"/_next/static/media/contact.ed7c2b28.svg","height":40,"width":40};